// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EPsG","label":"styles_label__3W9v_"};